import { TEMPLATE_IMAGE } from '~/constants/template';
import { GEmptyState } from '~/presentation/common';
import { GBlockCenter } from '~/presentation/ui';
import { useTranslation } from 'react-i18next';
import { Text } from '@shopify/polaris';

interface IProps {
  /** Tells "the keyword matched nothing" apart from "no experiment holds this template any more". */
  hasKeyword: boolean;
  isRefreshing?: boolean;
  onRefresh: () => void;
}

/**
 * The list reads live, so removing the last experiment empties it while the modal stays open — the
 * same empty state a keyword that matched nothing lands on, and the one a failed query lands on too.
 */
export const EditExperimentEmptyState: React.FC<IProps> = ({
  hasKeyword,
  isRefreshing,
  onRefresh,
}) => {
  const { t } = useTranslation();

  return (
    <GBlockCenter minHeight="calc(80vh - 194px)">
      <GEmptyState
        heading={t('No experiment found')}
        secondaryAction={{
          content: t('Refresh to update'),
          disabled: isRefreshing,
          onAction: onRefresh,
        }}
        image={TEMPLATE_IMAGE.EMPTY_TEMPLATE}
      >
        <Text as="p">
          {hasKeyword
            ? t('Check your keyword and try again')
            : t('This template is no longer in any experiment')}
        </Text>
      </GEmptyState>
    </GBlockCenter>
  );
};
